import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { FinancialService } from "../../services/financial.service";

interface MonthData {
  date: string;
  budget: number;
  spend: number;
  status: string; // blue, double, red, white
}

@Component({
  selector: "app-finance-calendar-view",
  templateUrl: "./finance-calendar-view.component.html",
  styleUrls: ["./finance-calendar-view.component.scss"],
})
export class FinanceCalendarViewComponent implements OnInit, OnDestroy {
  @Input() projectId!: number;
  loading: boolean = true;
  distribution: MonthData[] = [];

  calendarByYear: { [year: number]: MonthData[] } = {};

  constructor(private readonly finacialService: FinancialService) {}

  get calenderYears() {
    return Object.keys(this.calendarByYear);
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.finacialService
      .getCalendarViewData(this.projectId)
      .subscribe((resposne: any) => {
        this.distribution = resposne?.distribution;
        this.groupByYear();
        this.loading = false;
      });
  }

  getFormattedValue(val: number): string {
    if (!val) return "0";

    const absVal = Math.abs(val);
    if (absVal >= 1e9) {
      return (val / 1e9).toFixed(1) + "B";
    } else if (absVal >= 1e6) {
      return (val / 1e6).toFixed(1) + "M";
    } else if (absVal >= 1e3) {
      return (val / 1e3).toFixed(1) + "K";
    } else {
      const formattedVal = absVal.toFixed(2);
      return formattedVal.toString();
    }
  }
  ngOnDestroy() {}

  private groupByYear() {
    this.calendarByYear = this.distribution.reduce((acc, month) => {
      const year = new Date(month.date).getFullYear();
      if (!acc[year]) {
        acc[year] = [];
      }

      acc[year].push(month);
      return acc;
    }, {} as { [year: number]: MonthData[] });
  }

  getMonthName(dateStr: string): string {
    const month = new Date(dateStr).getMonth();
    return new Date(0, month).toLocaleString("default", { month: "short" });
  }
}
